/* tslint:disable */
/* eslint-disable */
/**
 * Kapybro Frontend Api Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: hello@roguepaws.dev
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    RepoActivation,
    RepoActivationFromJSON,
    RepoActivationFromJSONTyped,
    RepoActivationToJSON,
} from './';

/**
 * 
 * @export
 * @interface Repo
 */
export interface Repo {
    /**
     * 
     * @type {number}
     * @memberof Repo
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof Repo
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Repo
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof Repo
     */
    stars: number;
    /**
     * 
     * @type {string}
     * @memberof Repo
     */
    defaultBranch: string;
    /**
     * 
     * @type {boolean}
     * @memberof Repo
     */
    isPrivate: boolean;
    /**
     * 
     * @type {RepoActivation}
     * @memberof Repo
     */
    activation: RepoActivation;
    /**
     * 
     * @type {boolean}
     * @memberof Repo
     */
    hasConfig: boolean;
}

export function RepoFromJSON(json: any): Repo {
    return RepoFromJSONTyped(json, false);
}

export function RepoFromJSONTyped(json: any, ignoreDiscriminator: boolean): Repo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'stars': json['stars'],
        'defaultBranch': json['defaultBranch'],
        'isPrivate': json['isPrivate'],
        'activation': RepoActivationFromJSON(json['activation']),
        'hasConfig': json['hasConfig'],
    };
}

export function RepoToJSON(value?: Repo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'description': value.description,
        'stars': value.stars,
        'defaultBranch': value.defaultBranch,
        'isPrivate': value.isPrivate,
        'activation': RepoActivationToJSON(value.activation),
        'hasConfig': value.hasConfig,
    };
}

